import { connect } from 'react-redux'
import CancelSignup from './cancel-signup'
import { apiLogout } from '../../../../../common/api/profile'
import { withRouter } from 'react-router'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapDispatchToProps = (dispatch, { history }) => ({
  onCancel: () => apiLogout().catch(errorHandler) && history.push('/')
})

export default withRouter(
  connect(
    null,
    mapDispatchToProps
  )(CancelSignup)
)
